import React, { useState } from "react"
import Tooltip from "./Tooltip"

const cookies = () => {
  return document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    acc[name] = value;
    return acc;
  }, {});
}

const KEY_NAME = '_letter_atlas_onboarding_step'
const ONBOARDING_STEPS = [
  "categories",
  "plan",
  "done",
]
const ONBOARDING_TEXTS = [
  (
    <>
      <p className="text-xs mb-2">Your detected categories and newsletters will show along the left...</p>
      <p className="text-xs mb-2">Select the categories and newsletters that you want Letter Atlas to know about.</p>
      <p className="text-xs mb-2">Anything you do not select will never be processed by us, allowing you privacy by default!</p>
    </>
  ),
  (
    <>
      <p className="text-xs mb-2">Your account has a plan with credits. We've given you some for free!</p>
      <p className="text-xs mb-2">Enabling a category costs 250 credits, a publisher 50, and audio 750.</p>
      <p className="text-xs mb-2">If you run out of credits consider upgrading your plan!</p>
    </>
  ),
  (
    <>
      <p className="text-xs mb-2">You're all set!</p>
      <p className="text-xs mb-2">Click "Generate Digest" when you're ready to see a digest based on your selections.</p>
    </>
  )
]
const ONBOARDING_CLASSES = [
  "absolute left-3 top-[10%] z-50 animate-fade-in",
  "absolute left-3 top-[60%] z-50 animate-fade-in",
  "absolute left-3 top-[4%] z-50 animate-fade-in",
]

export const getIsOnboarding = () => {
  if (!cookies()[KEY_NAME]) {
    // document.cookie = `${KEY_NAME}=${ONBOARDING_STEPS[0]}`
    return true
  } else {
    const onboardingStep = cookies()[KEY_NAME]
    return onboardingStep !== ONBOARDING_STEPS[ONBOARDING_STEPS.length - 1]
  }
}

const getOnboardingStep = () => {
  const i = ONBOARDING_STEPS.findIndex(step => step === cookies()[KEY_NAME])
  if (i === -1) {
    return ONBOARDING_STEPS[0]
  }

  return ONBOARDING_STEPS[i]
}

export const Onboarding = ({ onComplete }) => {
  const [onboardingStep, setOnboardingStep] = useState(getOnboardingStep())

  const setNextOnboardingStep = () => {
    const cookieValue = cookies()[KEY_NAME]
    const i = ONBOARDING_STEPS.findIndex(step => step === cookieValue)
    if (onboardingStep !== ONBOARDING_STEPS[ONBOARDING_STEPS.length - 1]) {
      const nextStep = ONBOARDING_STEPS[i === -1 ? 1 : i + 1]
      if (nextStep) {
        const farFuture = new Date();
        farFuture.setFullYear(farFuture.getFullYear() + 100);
        document.cookie = `${KEY_NAME}=${nextStep};expires=${farFuture.toUTCString()};path=/`;
        setOnboardingStep(nextStep)
      }
    } else {
      onComplete && onComplete()
    }
  }

  const onboardingStepIndex = ONBOARDING_STEPS.findIndex((step) => step === onboardingStep)
  return (
    <div className={ONBOARDING_CLASSES[onboardingStepIndex]}>
      <Tooltip
        content={ONBOARDING_TEXTS[onboardingStepIndex]}
        closeText={onboardingStep !== ONBOARDING_STEPS[ONBOARDING_STEPS.length - 1] ? "Got it" : "Close"}
        onClose={setNextOnboardingStep}
      />
    </div>
  )
}

export default Onboarding
